import {createStore} from 'vuex';
import strategy from './strategy';
import situation from './situation';
import {getInfo, getSubId, checkUserAbandon, getAccessInfo, getSupplyId} from '@/request/api';
import {isBaiduerType, isManager, setCookie, getCookie} from '@/util/util';
import {ElMessage as Message} from '@/lib/element-polyfill';
import {GLOBAL_SUPPLY_ID} from '@/util/constant';
import {ServiceCode} from '@/enmus/CommonCode';
import AccessController from '@/models/AccessController';
import {computed} from 'vue';
import _ from 'lodash';

const store = createStore({
    modules: {
        strategy,
        situation
    },
    state: {
        init: false,
        user: null,
        supplyId: '',
        subid: '',
        supplyIdList: [],
        subidList: [],
        singleEndSubidList: [],
        beforeSupplyIdChangeQueue: [],
        globalLoading: false,
        globalReloadQueue: [],
        globalRequestError: false,
        accessController: new AccessController()
    },
    actions: {
        doInit({dispatch, rootState, commit}) {
            if (rootState.init) {
                return Promise.resolve(ServiceCode.SUCCESS);
            }
            return Promise.all([
                dispatch('fetchAccessInfo'),
                dispatch('fetchSupplyId')
            ]).then(res => {
                if (res.find(r => !r)) {
                    Message.error('获取数据失败');
                    return ServiceCode.ERROR;
                }
                dispatch('initSupplyId');
                commit('setInit', true);
                return ServiceCode.SUCCESS;
            }).catch(e => {
                console.error(e);
                return ServiceCode.FAIL;
            });
            // return dispatch('isUserDisabled').then(code => {
            //     if (code === ServiceCode.ERROR) {
            //         return ServiceCode.ERROR;
            //     }
            //     if (code === ServiceCode.SUCCESS) {
            //         return Promise.all([
            //             dispatch('fetchAccessInfo'),
            //             dispatch('fetchSupplyId')
            //         ]).then(res => {
            //             if (res.find(r => !r)) {
            //                 Message.error('获取数据失败');
            //                 return ServiceCode.ERROR;
            //             }
            //             dispatch('initSupplyId');
            //             commit('setInit', true);
            //             return ServiceCode.SUCCESS;
            //         }).catch(e => {
            //             console.error(e);
            //             return ServiceCode.FAIL;
            //         });
            //     } else {
            //         return ServiceCode.FAIL;
            //     }
            // });
        },
        fetchSupplyId({dispatch, rootState}) {
            return getSupplyId({}).then(response => {
                if (response.res === 0) {
                    const availableSupply = response.data.filter(v => {
                        return v.text;
                    });
                    dispatch('initSupplyIdList', availableSupply.sort((a, b) => {
                        return parseInt(b.supplyId, 10) - parseInt(a.supplyId, 10);
                    }));
                    return dispatch('fetchSubId', {supplyId: rootState.supplyId});
                }
                return false;
            });
        },
        fetchAccessInfo({dispatch}) {
            return getAccessInfo().then(response => {
                if (response.res === 0) {
                    dispatch('initAccessInfo', response.data);
                    return true;
                }
                return false;

            });
        },
        isUserDisabled() {
            return checkUserAbandon().then(response => {
                if (response.res === 0) {
                    if (response.data === '1') {
                        // code 200 成功
                        return ServiceCode.SUCCESS;
                    }
                    // code 201 失败用户不可用
                    return ServiceCode.FAIL;

                }
                // 500表示无服务器错误
                return ServiceCode.ERROR;

            }).catch(e => {
                console.error(e);
                return ServiceCode.ERROR;
            });
        },
        setAuth({commit}, {user, supplyId}) {
            commit('setUser', user);
            supplyId && commit('setSupplyId', supplyId + '');
        },
        fetchSubId({commit}, querys) {
            commit('setSubIdList', []);
            const subidPromise = getSubId(querys).then(response => {
                commit('setSubIdList', response && response.data || []);
                return response.res === 0;
            });
            const singleEndSubidPromise = getSubId({...querys, type: 'singleEnd'}).then(response => {
                commit('setSingleEndSubIdList', response && response.data || []);
                return response.res === 0;
            });
            return Promise.all([subidPromise, singleEndSubidPromise]).then(results => {
                return !results.includes(false);
            });
        },
        initUserInfo({commit, dispatch}, querys) {
            return getInfo(querys).then(response => {
                const {res, data} = response;
                if (res !== 0) {
                    return null;
                }
                dispatch('initAuth', data);
                return response;
            });
            // .catch(e => {
            //     const msg = e.message;
            //     if (msg.includes('Network Error')) { // 网络错误处理
            //         commit('setGlobalRequestError', true);
            //     }
            // });
        },
        initAuth({commit, dispatch, state, rootState}, data) {
            const user = {
                ...data,
                userId: data.userId,
                account: data.accountName,
                supplyId: data.supplyId,
                userType: data.userType
            };
            dispatch('setAuth', {user});
            dispatch('initSupplyId');
        },
        initSupplyId({commit, rootState, getters}) {
            if (!rootState.supplyId) {
                const isBaiduer = getters.isBaiduer;
                const cookieSupplyId = (getCookie('selectedSupplyId') || '').replace(/"/g, '');
                const cookieSubId = (getCookie('selectedSubId') || '').replace(/"/g, '');
                let supplyId = cookieSupplyId;
                if (!isBaiduer && !supplyId) {
                    supplyId = _.get(rootState.user, 'supplyList[0].supplyId');
                }
                setCookie('selectedSupplyId', supplyId, 10);
                if (!cookieSubId) {
                    setCookie('selectedSubId', cookieSubId, 10);
                }
                commit('setSupplyId', supplyId);
                commit('setSubId', cookieSubId);
            }
        },
        toggleSupplyId({dispatch, rootState, commit}, {supplyId}) {
            const {supplyIdList} = rootState;
            const permission = supplyIdList.find(item => `${item.supplyId}` === supplyId);
            if (permission) {
                return dispatch('fetchSubId', {supplyId}).then(success => {
                    if (success) {
                        setCookie('selectedSupplyId', supplyId, 10);
                        setCookie('selectedSubId', '', 10);
                        commit('setSupplyId', supplyId);
                        commit('setSubId', '');
                    } else {
                        throw new Error('server error');
                    }
                });
            }
            return Promise.resolve();
        },
        clearAuth({commit}) {
            commit('setInit', false);
            commit('setIsManager', false);
            commit('setIsBaiduer', false);
            commit('setUser', null);
            commit('setSupplyId', '');
            commit('setSubId', '');
        },
        initSupplyIdList({commit, getters, rootState}, supplyIdList) {
            const isBaiduer = getters.isBaiduer;
            const {user} = rootState;
            if (isBaiduer) {
                commit('setSupplyIdList', supplyIdList);
            } else {
                const {supplyList} = user;
                commit('setSupplyIdList', supplyIdList.filter(item => {
                    const hasSupply = supplyList.find(v => `${v.supplyId}` === `${item.supplyId}`);
                    return hasSupply;
                }));
            }
        },
        initAccessInfo({commit, rootState}, accessInfo) {
            commit('setAccessInfo', accessInfo);
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setSupplyId(state, supplyId) {
            state.supplyId = supplyId;
        },
        setSubId(state, subid) {
            state.subid = subid;
        },
        setInit(state, v) {
            state.init = v;
        },
        setSupplyIdList(state, supplyIdList) {
            state.supplyIdList = supplyIdList;
            // let i = 5000060496;
            // state.supplyIdList = supplyIdList.map(item => {
            //     item.thirdId = i;
            //     return item;
            // });
        },
        setSubIdList(state, subidList) {
            state.subidList = subidList.filter(v => v);
        },
        setSingleEndSubIdList(state, subidList) {
            state.singleEndSubidList = subidList.filter(v => v);
        },
        setGlobalRequestError(state, value) {
            state.globalRequestError = value;
        },
        addSupplyIdChangeListener(state, fun) {
            state.beforeSupplyIdChangeQueue.push(fun);
        },
        removeSupplyIdChangeListener(state, fun) {
            state.beforeSupplyIdChangeQueue = state.beforeSupplyIdChangeQueue.filter(v => v !== fun);
        },
        setAccessInfo(state, accessInfo) {
            state.accessController.initAccess(accessInfo);
            state.accessInfo = {
                strategyCenter: (accessInfo.strategyCenter || []).map(v => v + ''),
                dataReport: (accessInfo.dataReport || []).map(v => v + ''),
                subid: (accessInfo.subid || []).map(v => v + ''),
                logReport: (accessInfo.logReport || []).map(v => v + ''),
                singleEndLog: (accessInfo.singleEndLog || []).map(v => v + ''),
                intelligence: (accessInfo.intelligence || []).map(v => v + ''),
                apiServerMonitor: (accessInfo.apiServerMonitor || [2055, 2033, 2045]).map(v => v + '')
            };
        }
    },
    getters: {
        supplyIdMap(state) {
            const supplyIdList = state.supplyIdList || [];
            const map = {[GLOBAL_SUPPLY_ID]: '百度'};
            supplyIdList.forEach(item => {
                map[item.supplyId] = item.text;
            });
            return map;
        },
        isManager(state, getters) {
            const {user, supplyId} = state;
            if (!user) {
                return false;
            }
            const {supplyList} = user;
            const {isBaiduer} = getters;
            if (isBaiduer) {
                return isManager(user.userType);
            }
            if (!supplyList || !supplyId) {
                return false;
            }
            const supplyInfo = supplyList.find(v => `${v.supplyId}` === `${supplyId}`);
            if (!supplyInfo) {
                return false;
            }
            return supplyInfo.type === 'customerManager';
            // return !!user && isManager(user.userType);
        },
        isMultSupplyUser(state, getters) {
            const {isBaiduer} = getters;
            if (isBaiduer) {
                return true;
            }
            const {user} = state;
            if (!user) {
                return false;
            }
            const {supplyList} = user;
            return supplyList?.length >= 2;
        },
        isBaiduer(state) {
            const user = state.user;
            return !!user && isBaiduerType(user.userType);
        },
        supplyItemMap(state) {
            const supplyIdList = state.supplyIdList || [];
            const map = {[GLOBAL_SUPPLY_ID]: {text: '百度', thirdId: ''}};
            supplyIdList.forEach(item => {
                map[item.supplyId] = item;
            });
            return map;
        }
    }
});

export function useState(stateKey = '') {
    if (!stateKey) {
        return store.state;
    }
    const keys = stateKey.split('/');
    let state = store.state;
    keys.forEach(key => {
        state = state[key];
    });
    return state;
}

export function useComputedState(stateKey = '') {
    return computed(() => useState(stateKey));
}

window.store = store;
export default store;